// Cross-sell Tracking SDK - Main Entry Point

// 导出类型
export type {
  ApiResponse,
  CrossSellConfig,
  CrossSellEnvironment,
  CrossSellError,
  EventType,
  InitAppRequest,
  InitAppResponse,
  LogEventRequest,
  LogEventResponse,
  GetRedirectUrlParams,
  GetContactRedirectUrlParams,
  ContactType,
  SourceType,
} from "./types"

// 导出常量和枚举
export { EVENT_TYPES, CROSS_SELL_APP_KEY, CONTACT_TYPES, SOURCE_TYPES } from "./types"

// 导出主类
export { CrossSellTracker } from "./tracker"

// 导出工具函数
export { getTraceIdFromCookie, setTraceIdToCookie } from "./utils"

// 导出工厂函数和全局管理
import { CrossSellTracker } from "./tracker"
import type { CrossSellConfig } from "./types"

/**
 * 创建Cross-sell Tracker实例的工厂函数
 */
export const createCrossSellTracker = (config: CrossSellConfig): CrossSellTracker => {
  return new CrossSellTracker(config)
}

/**
 * 全局实例管理
 */
declare global {
  interface Window {
    CrossSellTracker: CrossSellTracker | undefined
    crossSellTracker: CrossSellTracker | undefined
  }
}

/**
 * 初始化全局Cross-sell Tracker实例
 */
export const initGlobalCrossSellTracker = (config: CrossSellConfig): CrossSellTracker => {
  // 如果已经初始化过，直接返回现有实例
  if (typeof window !== "undefined" && window.crossSellTracker) {
    console.warn("[CrossSellTracker] Global instance already exists, returning existing instance")
    return window.crossSellTracker
  }

  const tracker = new CrossSellTracker(config)

  if (typeof window !== "undefined") {
    // 绑定到window对象，提供两种访问方式
    window.crossSellTracker = tracker
    window.CrossSellTracker = tracker

    console.log("[CrossSellTracker] Global instance initialized and bound to window")
  }

  return tracker
}

/**
 * 获取全局Cross-sell Tracker实例
 */
export const getGlobalCrossSellTracker = (): CrossSellTracker | null => {
  if (typeof window === "undefined") {
    console.warn("[CrossSellTracker] Window object not available")
    return null
  }

  if (!window.crossSellTracker) {
    console.warn("[CrossSellTracker] Global instance not initialized. Please call initGlobalCrossSellTracker first")
    return null
  }

  return window.crossSellTracker
}

/**
 * 销毁全局Cross-sell Tracker实例
 */
export const destroyGlobalCrossSellTracker = (): void => {
  if (typeof window !== "undefined" && window.crossSellTracker) {
    // 移除全局引用
    window.crossSellTracker = undefined
    window.CrossSellTracker = undefined

    console.log("[CrossSellTracker] Global instance destroyed")
  }
}

// 默认导出主类
export default CrossSellTracker
